<template>

      <div class="cc-list dt-list">
        <div
          draggable
          @dragenter.prevent 
          @dragover.prevent 
          @drop.prevent="drop" 
          @dragstart="dragstart" 
          class="cc-item dt-list-item"
          v-for="(item,index) of items"
          :key="item.checklist_id"
          :id="index"
        >
          <div class="dt-list-item--body">
         
            <!-- <span
            
            > {{item[labelKey]}} </span> -->
            <input
              class="dt-textbox"
              type="text"
              :value="item[labelKey]"
              @blur="e => onBlur(e, item)"
            />
          </div>
          <div class="dt-list-item--options">
              <div class="dt-icon-container">
                  <img src="static/icons/close.svg"
                    @click="e => onDelete(e, item)" 
                    class="dt-icon v5 s1"
                    alt="Delete Checklist" 
                    title="Delete Checklist" 
                    >
              </div>
            <!-- <button class="remove-cci" >
              <v-icon>close</v-icon>
            </button> -->
          </div>
        </div>
      </div>

</template>

<script>


export default {
  components: {
    //Modal
  },
  props: {
    items: {
      type: Array
    },
    labelKey:
    {
      type:String
    }
  },
  data: function() {
    return {
      checklist_title: ""
    };
  },
  methods: {

    onBlur: function(e, item) {
      
      if (e.target.value !== item.name) {
        this.$emit("onBlur", { item, newName: e.target.value });
      }
    },
  
    onDelete: function(e, item) {
      this.$emit("onDelete", item);
    },

    dragstart:function()
    {
      event.dataTransfer.setData("text",event.target.id)
      console.log("DRAG:",event.target.id)
    },
    drop:function()
    { 
      let draggeddata=event.dataTransfer.getData("text")
      let droppeddata=event.target.id
      console.log("DRAGGED DATA:",draggeddata,"DROPPED DATA:",droppeddata)
      this.items.splice(droppeddata,1,this.items[draggeddata])
      this.items.splice(draggeddata,1,event.target.textContent)
      console.log("DROP:",event.target.textContent)
      console.log(this.items)
      console.log("DROP:")
    }
    

  }
};
</script>

<style lang="scss" scoped>
.dt-list-item {
  border-bottom-color: transparent !important;
  margin: 5px 0px;
  padding: 5px 0px;

  .dt-list-item--options {
    max-width: 26px;
  }
}

.dt-modal--body {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.remove-cci {
  i {
    font-size: 13px;
    padding: 5px;
    transition: 200ms ease-out;

    &:hover {
      color: black;
      transform: scale(1.2);
    }
  }

  &:active,
  &:focus {
    outline: none;
    transform: scale(1);

    text-shadow: 0.3px 0.3px #000000ad;
  }
}
</style>
